<template>
  <Modal
    persistent
    hide-footer
    :value="value"
    @input="input"
    :title="$t('uploadFile.new')"
  >
    <p class="u-margin-bottom-small u-color-muted">
      <span> {{ $t("uploadFile.newFileDescription") }}</span>
    </p>
    <SuggestionInput
      v-model="suggestions"
      v-if="initSuggestions.length === 0"
      :label="$t('suggestionInput.label')"
      :request="getSuggestions"
      :placeholder="$t('suggestionInput.placeholder')"
      :block="true"
    >
      <template #suggestion="{ suggestion }">
        <chip variant="primary">
          <i class="icofont-plus"></i> {{ suggestion.title }}
        </chip>
      </template>
    </SuggestionInput>

    <div v-if="initSuggestions.length === 0" class="o-alert o-alert--info">
      {{ $t("uploadFile.selectTagInfo") }}
    </div>

    <div
      class="c-upload-area"
      @click="$refs.fileUpload.click()"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <i class="icofont-upload u-font-size-xlarge"></i>
      <p>
        <small>
          {{ $t("uploadFile.newFileDescription2") }}
          {{ $t("common.or") }}
        </small>
        <Button>
          {{ $t("uploadFile.choose") }}
        </Button>
      </p>
      <p>
        <small>{{ $t("uploadFile.maxLimit", { limit: 25 }) }}</small>
      </p>
      <input
        type="file"
        class="u-display-none"
        @change="change"
        ref="fileUpload"
      />
    </div>
    <ul class="c-list">
      <li class="c-list__item" v-for="(file, i) in files" :key="i">
        <chip variant="primary">
          <i class="icofont-file-document"></i> {{ file.name }}
        </chip>
        <Button variant="light-danger" size="sm" @click="files = []">
          <i class="icofont-close"></i>
        </Button>
      </li>
    </ul>
    <div class="u-margin-top-small">
      <Button block variant="primary" @click="upload">
        {{ $t("uploadFile.upload") }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";
import { mapGetters } from "vuex";
import api from "@/services/Api";
import SuggestionInput from "@/components/Base/Inputs/SuggestionInput.vue";
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import Chip from "@/components/Base/Chip.vue";

export default {
  components: { Modal, SuggestionInput, Button, Chip },
  computed: {
    ...mapGetters(["getDownloadProgress"]),
  },
  data() {
    return {
      progressEvent: api.progressEvent,
      suggestions: [],
      files: [],
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initSuggestions: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.suggestions = this.initSuggestions;
    },
    change(e) {
      this.files = e.target.files;
      this.checkFile();
    },
    getSuggestions(value) {
      return Requests.ProjectTag.GetAll({
        query: { search: value, limit: 10 },
      });
    },
    input(value) {
      this.$emit("input", value);
    },
    dragover(e) {
      e.preventDefault();
    },
    dragleave(e) {
      e.preventDefault();
    },
    drop(e) {
      e.preventDefault();
      this.files = e.dataTransfer.files;
      this.checkFile();
    },
    checkFile() {
      // prevent multiple files
      if (this.files.length > 1) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("uploadFile.onlyOneFile"),
          variant: "danger",
          duration: 2500,
        });
        return;
      }
      // check 25mb
      if (this.files[0].size > 25 * 1024 * 1024) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("uploadFile.maxLimit", { limit: 25 }),
          variant: "danger",
          duration: 2500,
        });
        return;
      }
      // Check files are not folder
      if (this.files[0].type === "") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("uploadFile.onlyFile"),
          variant: "danger",
          duration: 2500,
        });
        return;
      }
    },
    upload() {
      const name = new Date().getTime() + "-" + this.files[0].name;
      this.$emit("upload", {
        file: this.renameFile(this.files[0], name),
        tags: this.suggestions,
      });
    },
    renameFile(file, newName) {
      return new File([file], newName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
